import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b59a6774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm ecran-container" }
const _hoisted_2 = {
  class: "q-pa-md",
  style: {"max-width":"30rem","margin":"auto"}
}
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_form, {
        onSubmit: _ctx.onSubmit,
        onReset: _ctx.onReset,
        class: "q-gutter-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_select, {
            outlined: "",
            modelValue: _ctx.adresa.codTara,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adresa.codTara) = $event)),
            options: _ctx.countryOptions,
            label: _ctx.$t('message.country'),
            "option-value": "code",
            "option-label": _ctx.$i18n.locale == 'de' ? 'name_de' : _ctx.$i18n.locale == 'ro' ? 'name_ro' : _ctx.$i18n.locale == 'en' ? 'name_en' : 'name_hu',
            class: "form__input",
            "lazy-rules": "",
            "emit-value": "",
            "map-options": "",
            rules: [ val => val && val.length > 0 || _ctx.$t('message.enter_field')]
          }, null, 8, ["modelValue", "options", "label", "option-label", "rules"]),
          (_ctx.adresa.codTara == 'RO')
            ? (_openBlock(), _createBlock(_component_q_select, {
                key: 0,
                outlined: "",
                "use-input": "",
                modelValue: _ctx.adresa.adresaCodJudet,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adresa.adresaCodJudet) = $event)),
                options: _ctx.judeteOptions,
                label: _ctx.$t('message.county'),
                "option-value": "code",
                "option-label": "name",
                class: "form__input",
                "lazy-rules": "",
                "emit-value": "",
                "map-options": ""
              }, null, 8, ["modelValue", "options", "label"]))
            : (_openBlock(), _createBlock(_component_q_input, {
                key: 1,
                outlined: "",
                modelValue: _ctx.adresa.denJudet,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adresa.denJudet) = $event)),
                label: _ctx.$t('message.county'),
                class: "form__input",
                "lazy-rules": ""
              }, null, 8, ["modelValue", "label"])),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: _ctx.adresa.adresaLocalitate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.adresa.adresaLocalitate) = $event)),
            label: _ctx.$t('message.city'),
            class: "form__input",
            "lazy-rules": "",
            rules: [ val => val && val.length > 0 || _ctx.$t('message.enter_field')]
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: _ctx.adresa.adresaAdresa,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adresa.adresaAdresa) = $event)),
            label: _ctx.$t('message.address'),
            class: "form__input",
            "lazy-rules": "",
            rules: [ val => val && val.length > 0 || _ctx.$t('message.enter_field')]
          }, null, 8, ["modelValue", "label", "rules"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.reset'),
              type: "reset",
              flat: "",
              class: "q-ml-sm"
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.save'),
              type: "submit",
              style: {"background-color":"#9b7d32","color":"white"}
            }, null, 8, ["label"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onReset"])
    ])
  ]))
}